/**
 * NOTE: This module is used in student header.
 */

import * as React from 'react';

import HeaderLogo from 'HeaderLogo';
import HeaderRoomName from 'HeaderRoomName';

export default class BaseHeaderView extends React.Component {
  render() {
    return (
      <div id="base-header">
        <HeaderLogo {...this.props} />
        <HeaderRoomName {...this.props} />
        {this.props.children}
      </div>
    );
  }
}
